// extracted by mini-css-extract-plugin
export default {"hint":"hint--0bb1e1","link":"link--951294","link-icon":"link-icon--e20189","linkIcon":"link-icon--e20189","instruction":"instruction--6965f7"};